import { defineStore } from 'pinia';
import type { ExtraGuaranteeSidebarState } from '~~/types/vuex/ExtraGuaranteeSidebar';

export const extraGuaranteeSidebarStore = defineStore('extraGuaranteeSidebar', {
  state: () => ({ isExtraGuaranteeOpen: false as ExtraGuaranteeSidebarState['isExtraGuaranteeOpen'] | null }),
  actions: {
    setIsExtraGuaranteeOpen(payload: ExtraGuaranteeSidebarState['isExtraGuaranteeOpen'] | null) {

      this.isExtraGuaranteeOpen = payload; 

    },
  },
});
